export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8856.c48a8584.jpg";